var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",attrs:{"id":"app"}},[(_vm.loggedIn || _vm.access_token)?_c('headerDefault'):(_vm.page401)?_c('headerUnsigned'):_vm._e(),(_vm.loggedIn || _vm.access_token)?_c('SideBar'):_vm._e(),_c('div',{class:{
      'content-wrapper px-lg-5 px-xl-5 px-md-5 px-3 py-4':
        _vm.loggedIn || _vm.access_token,
    }},[_c('ModalPassword'),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1),(_vm.loggedIn || _vm.access_token || _vm.page401)?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }